import React from "react"

export const renderGlobalMetaTags = (globalMetaTags) =>
  globalMetaTags ?
    globalMetaTags.map(({ id, name, content } = {}) =>
      <meta key={id} name={name} content={content}/>
    )
    :
    null
